import { useCurrentDrivingSchoolId } from "../../hooks/useCurrentDrivingSchoolId";
import { useNavigate } from "react-router";
import { List } from "react-admin";
import { Row } from "../../misc/Row";
import { PageTitle } from "../../misc/PageTitle";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { grants } from "../../backoffice.access_control";
import { AccessDenied } from "../../misc/AccessDenied";
import { EmptyState } from "../../misc/EmptyState";
import Alert from "@mui/material/Alert";
import { Column } from "../../misc/Column";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { CustomCardsDataGrid } from "./CustomCardsDataGrid";

export function DrivingSchoolCustomCards() {
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const navigate = useNavigate();

  if (!grants.has("CustomCard:list")) {
    return <AccessDenied />;
  }

  const empty = <EmptyState />;

  return (
    <Column>
      <Alert severity="info" sx={{ mb: 2 }}>
        Du kannst hier beliebige Angebote oder Informationen mit einem Bild und Link hinterlegen, die deinen
        Fahrschülern im Cockpit der AUTOVIO App angezeigt werden.
      </Alert>
      <div style={{ position: "relative" }}>
        <Row
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: "30px", minHeight: "32px", columnGap: 2, flexWrap: { xs: "wrap", sm: "nowrap" }, rowGap: 1 }}
        >
          <PageTitle documentTitle="App Cockpit Teaser">
            <h2 style={{ margin: 0, lineHeight: 0.83 }}>App Cockpit Teaser</h2>
          </PageTitle>
          {grants.has("CustomCard:create") && (
            <>
              <IconButton
                aria-label="Teaser hinzufügen"
                color="primary"
                onClick={() => navigate("/customCards/create")}
                size="small"
                sx={{ display: { xs: "inline-flex", sm: "none" } }}
              >
                <AddIcon />
              </IconButton>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => navigate("/customCards/create")}
                size="small"
                sx={{ display: { xs: "none", sm: "inline-flex" } }}
              >
                Hinzufügen
              </Button>
            </>
          )}
        </Row>
        <ResponsiveListSurface variant="compactStandalone" data-testid="DrivingSchoolCustomCards">
          <List
            resource="customCards"
            title=" "
            actions={false}
            filter={{ drivingSchoolId }}
            sort={/* initial sort order: */ { field: "id", order: "ASC" }}
            exporter={false}
            hasCreate={false}
            empty={empty}
          >
            <CustomCardsDataGrid empty={empty} />
          </List>
        </ResponsiveListSurface>
      </div>
    </Column>
  );
}
